import { useFlowContext } from './'

export const useNativeApp = () => {
  const flowContext = useFlowContext()
  return flowContext?.getOptions()?.isNativeApp
}
